import React, { Component } from 'react';
import styled from 'styled-components';

import { SearchInput } from '@shared/fields/SearchInput';
import media from '../../../utils/mediaQueries';
import { AlgoliaService } from '../../../services/AlgoliaService';
import { AUTOCOMPLETE_SETTINGS } from '../../../constants';

const SearchForm = styled.form`
  display: none;
  
  ${media.mobile`
    display: block;
  `}
`;

class ExamCentersSearch extends Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();

    this.state = {
      searchInputDefaultValue: '',
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.href);
    if (searchParams.get('location')) {
      this.setState({ searchInputDefaultValue: searchParams.get('location') });
    }

    const client = algoliasearch(
      process.env.ALGOLIA_SEARCH_APP_ID || 'FF7QA0O6MW',
      process.env.ALGOLIA_SEARCH_API_KEY,
    );
    const index = client.initIndex(
      // TODO: fix in https://clickclickdrive.atlassian.net/browse/CCD-5194
      // Left default value for backward compatibility
      process.env.ALGOLIA_INDEX_EXAM_CENTER || 'ExamCenter_production',
    );
    const rentalsDataset = {
      source: autocomplete.sources.hits(index, { hitsPerPage: 3 }),
      displayKey: 'title',
      name: 'rentals',
      templates: {
        header: '<div class="ad-example-header" style="padding-left: 12px; background-color: #E8E8E8; border-radius: 2px;">Centre d\'examens</div>',
      },
      debounce: 300,
    };

    const placesDataset = AlgoliaService.generatePlacesDataset();

    const search_input = this.searchInputRef.current;

    const autocompleteInstance = autocomplete(search_input, AUTOCOMPLETE_SETTINGS, [
      placesDataset,
      rentalsDataset,
    ]);

    const autocompleteChangeEvents = ['selected', 'autocompleted'];

    autocompleteChangeEvents.forEach((eventName) => {
      autocompleteInstance.on(`autocomplete:${eventName}`, (event, suggestion, datasetName) => {
        if (datasetName === 'places') {
          const latitude = suggestion.center[1];
          const longitude = suggestion.center[0];
          window.location.href = `/centres-code-de-la-route?latitude=${latitude}&longitude=${longitude}&location=${search_input.value}`;
        } else if (datasetName === 'rentals') {
          window.location.href = suggestion.path_exam_center;
        }
      });
    });
  }

  render() {
    const { searchInputDefaultValue } = this.state;
    return (
      <SearchForm>
        <SearchInput ref={this.searchInputRef} placeholder="Où cherchez-vous un centre?" type="text" defaultValue={searchInputDefaultValue} />
      </SearchForm>
    );
  }
}

export { ExamCentersSearch };
